"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.takePicture = exports.getAppInfo = exports.getNetworkStatus = exports.getUserDataObject = exports.getSingleGameByToken = exports.getGamesByChallengerId = exports.getAllGameData = exports.getGroupUsers = exports.getUser = exports.getDataObjectsByType = exports.postGameData = exports.DATA_OBJECT_TYPE_USER = exports.DATA_OBJECT_TYPE_GAME_GROUP = exports.DATA_OBJECT_TYPE_GAME = exports.PLUGIN_EQUIZZER = exports.FEATURE_NAME = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _CordovaHelper = require("../../../../helpers/CordovaHelper");

var _DataObjectService = _interopRequireDefault(require("./DataObjectService"));

var FEATURE_NAME = 'equeoqd';
exports.FEATURE_NAME = FEATURE_NAME;
var PLUGIN_EQUIZZER = 'EquizzerPlugin';
exports.PLUGIN_EQUIZZER = PLUGIN_EQUIZZER;
var DATA_OBJECT_TYPE_GAME = 'EquizzerGame';
exports.DATA_OBJECT_TYPE_GAME = DATA_OBJECT_TYPE_GAME;
var DATA_OBJECT_TYPE_GAME_GROUP = 'EquizzerUserGroup';
exports.DATA_OBJECT_TYPE_GAME_GROUP = DATA_OBJECT_TYPE_GAME_GROUP;
var DATA_OBJECT_TYPE_USER = 'EquizzerUser';
/*
 * calls postDataObject in DataObjectService
 * gets a data object with type, value and feature
 * returns a Promise resolve when it gets and Object back and the syncstate is ok
 * else rejects the promise
 * Input: gameObject -> object, Output: Object from the server containing the latest posted DataObjects by type and there syncstate
 */

exports.DATA_OBJECT_TYPE_USER = DATA_OBJECT_TYPE_USER;

var postGameData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(gameObject) {
    var dataObject, object, responseObject;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dataObject = {
              type: DATA_OBJECT_TYPE_GAME,
              value: gameObject,
              feature: FEATURE_NAME
            };
            _context.prev = 1;
            _context.next = 4;
            return _DataObjectService["default"].postDataObject(dataObject);

          case 4:
            object = _context.sent;
            responseObject = object.data.dataobjects.find(function (object) {
              return object.type === DATA_OBJECT_TYPE_GAME && object.syncState === 'ok';
            });

            if (!responseObject) {
              _context.next = 9;
              break;
            }

            console.log('postGameData successful', responseObject);
            return _context.abrupt("return", _promise["default"].resolve(responseObject.value));

          case 9:
            return _context.abrupt("return", _promise["default"].reject(new Error('object could not be posted')));

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _promise["default"].reject(_context.t0));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function postGameData(_x) {
    return _ref.apply(this, arguments);
  };
}();
/*
 * calls getDataObject in DataObjectService
 * takes a type of dataobject and gets all corresponding objects from the server
 * Input: type -> string, Output: Object with data from the server containing all dataobjects
 */


exports.postGameData = postGameData;

var getDataObjectsByType = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(type) {
    var response;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log('getDataObjectsByType with type', type);
            _context2.prev = 1;
            _context2.next = 4;
            return _DataObjectService["default"].getDataObjects(type);

          case 4:
            response = _context2.sent;
            console.log('getDataObjectsByType success', response);
            return _context2.abrupt("return", _promise["default"].resolve(response));

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            console.log('getDataObjectsByType error', _context2.t0);
            return _context2.abrupt("return", _promise["default"].reject(_context2.t0));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));

  return function getDataObjectsByType(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
/*
 * invokes getUser method from native code (android/ios)
 * provided feature name
 */


exports.getDataObjectsByType = getDataObjectsByType;

var getUser = function getUser() {
  return (0, _CordovaHelper.getPromise)(PLUGIN_EQUIZZER, 'getUser', [FEATURE_NAME]);
};
/*
 * calls getDataObject in DataObjectService
 * gets the game group object (there should be only one)
 * Promise.resolve when there is one, reject when there are more than one or an error while getting the object
 * Input: nothing, Output: exactly one Dataobject of type GameGroup
 */


exports.getUser = getUser;

var getGroupUsers = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return getDataObjectsByType(DATA_OBJECT_TYPE_GAME_GROUP);

          case 3:
            response = _context3.sent;
            console.log('getGroupUsers', response);

            if (!(response.data.dataobjects.length !== 1)) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return", _promise["default"].reject(new Error('got more than one object')));

          case 7:
            return _context3.abrupt("return", _promise["default"].resolve(response.data.dataobjects));

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", _promise["default"].reject(_context3.t0));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 10]]);
  }));

  return function getGroupUsers() {
    return _ref3.apply(this, arguments);
  };
}();
/*
 * calls getDataObject in DataObjectService
 * gets the all games with type DATA_OBJECT_TYPE_GAME
 * Input: nothing, Output: Array of Dataobjects with type game
 */


exports.getGroupUsers = getGroupUsers;

var getAllGameData = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return getDataObjectsByType(DATA_OBJECT_TYPE_GAME);

          case 3:
            response = _context4.sent;
            console.log('getAllGameData', response);
            return _context4.abrupt("return", _promise["default"].resolve(response.data.dataobjects));

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", _promise["default"].reject(_context4.t0));

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));

  return function getAllGameData() {
    return _ref4.apply(this, arguments);
  };
}();
/*
 * calls getDataObject in DataObjectService
 * gets the all games and returns the objects, where the challengerId matches one of the opponent/challenger in the game object
 * Input: challengerId -> string, Output: Array with dataobjects with matching Ids
 */


exports.getAllGameData = getAllGameData;

var getGamesByChallengerId = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(challengerId) {
    var response, games;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return getDataObjectsByType(DATA_OBJECT_TYPE_GAME);

          case 3:
            response = _context5.sent;
            games = [];
            response.data.dataobjects.forEach(function (game) {
              if (game.value.opponent === challengerId || game.value.challenger === challengerId) {
                games.push(game);
              }
            });
            return _context5.abrupt("return", _promise["default"].resolve(games));

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", _promise["default"].reject(_context5.t0));

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 9]]);
  }));

  return function getGamesByChallengerId(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
/*
 * calls getDataObject in DataObjectService
 * gets the all games and returns the object, where the tokenId matches the emsId in the dataobject
 * Input: tokenId -> string, Output: GameObject with matching emsId
 */


exports.getGamesByChallengerId = getGamesByChallengerId;

var getSingleGameByToken = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(tokenId) {
    var response, game;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return getDataObjectsByType(DATA_OBJECT_TYPE_GAME);

          case 3:
            response = _context6.sent;
            game = response.data.dataobjects.find(function (game) {
              return game.value.emsId === tokenId;
            });

            if (game) {
              _context6.next = 7;
              break;
            }

            return _context6.abrupt("return", _promise["default"].reject(new Error('no object found')));

          case 7:
            return _context6.abrupt("return", _promise["default"].resolve(game));

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", _promise["default"].reject(_context6.t0));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 10]]);
  }));

  return function getSingleGameByToken(_x4) {
    return _ref6.apply(this, arguments);
  };
}();
/*
 * calls getDataObject in DataObjectService
 * gets the user objects and returns all the objects, where the emsId in the dataobjects matches the given array emsId
 * Input: emsIds -> array of ids, Output: Array of matching DataObjects, empty Array possible
 */


exports.getSingleGameByToken = getSingleGameByToken;

var getUserDataObject = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(emsIds) {
    var response, objects;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!(!emsIds || emsIds.length === 0)) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return", _promise["default"].resolve([]));

          case 2:
            _context7.prev = 2;
            _context7.next = 5;
            return getDataObjectsByType(DATA_OBJECT_TYPE_USER);

          case 5:
            response = _context7.sent;
            objects = [];
            response.data.dataobjects.forEach(function (object) {
              if (emsIds.includes(object.value.emsId)) {
                objects.push(object);
              }
            });

            if (!objects) {
              _context7.next = 10;
              break;
            }

            return _context7.abrupt("return", _promise["default"].resolve(objects));

          case 10:
            return _context7.abrupt("return", _promise["default"].reject(new Error('no user found')));

          case 13:
            _context7.prev = 13;
            _context7.t0 = _context7["catch"](2);
            return _context7.abrupt("return", _promise["default"].reject(_context7.t0));

          case 16:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[2, 13]]);
  }));

  return function getUserDataObject(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

exports.getUserDataObject = getUserDataObject;

var getNetworkStatus = function getNetworkStatus() {
  return (0, _CordovaHelper.getPromise)(_CordovaHelper.PLUGIN_NETWORK_MANAGER, 'getConnectionInfo');
};

exports.getNetworkStatus = getNetworkStatus;

var getAppInfo = function getAppInfo() {
  return (0, _CordovaHelper.getPromise)(_CordovaHelper.PLUGIN_GENERAL_TASKS, 'getAppInfo');
};

exports.getAppInfo = getAppInfo;

var takePicture = function takePicture() {
  return (0, _CordovaHelper.getPromise)(_CordovaHelper.CAMERA_PLUGIN, 'takePicture', []
  /* [
  {
  destType: 0,
  srcType: 1,
  mQuality: 50,
  targetWidth: 0,
  targetHeight: 0,
  encodingType: 0,
  mediaType: 0,
  allowEdit: true,
  correctOrientation: true,
  saveToPhotoAlbum: true
  }
  ] */
  );
};

exports.takePicture = takePicture;